






import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import InputWithValidation from '@/mixins/InputWithValidation'

@Component({
  components: {}
})
export default class VTextAreaWithValidation extends Mixins(InputWithValidation) {}
